import { render } from "./BranchAttendance.vue?vue&type=template&id=4d40257e&scoped=true"
import script from "./BranchAttendance.vue?vue&type=script&lang=js"
export * from "./BranchAttendance.vue?vue&type=script&lang=js"

import "./BranchAttendance.vue?vue&type=style&index=0&id=4d40257e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d40257e"]])

export default __exports__